import { clearLoadingState } from './loading-state-helpers';

export default class Form {
  isValid = (form) => (
    this.validators.reduce((accumulator, validationSettings) => (
      validationSettings.validators.reduce((validatorsAccumulator, validatorClass) => {
        // eslint-disable-next-line new-cap
        const validator = new validatorClass(form, validationSettings.field, validationSettings.label);

        return validator.validate() && validatorsAccumulator;
      }, accumulator)
    ), true)
  );

  validate = (event, form) => {
    if (!this.isValid(form)) {
      event.preventDefault();

      clearLoadingState(this.getSubmitButton(form));

      return false;
    }

    return true;
  };
}
